import {
  MockTestSteps,
  MockTestOtpVerified,
  MockTestStep,
} from '../../api/models/mocktest';

/**
 * Updates URL query parameters without page reload
 * @param key Query parameter key to update
 * @param value Value to set for the query parameter
 */
export const updateUrlParam = (key: string, value: string) => {
  const params = new URLSearchParams(window.location.search);
  params.set(key, value);
  window.history.replaceState(
    {},
    '',
    `${window.location.pathname}?${params.toString()}`
  );
};

export const getUrlParam = (key: string) => {
  const params = new URLSearchParams(window.location.search);
  return params.get(key);
};

// In-memory state for mockTest (no reducers)
let mockTestMemory: any | null = null;

export const saveLocalStorage = (key: string, value: any) => {
  if (key === 'mockTest') {
    mockTestMemory = value;
    return;
  }
  // localStorage.setItem(key, JSON.stringify(value));
};

export const getLocalStorage = (key: string) => {
  if (key === 'mockTest') {
    return mockTestMemory ? JSON.stringify(mockTestMemory) : null;
  }
  // return localStorage.getItem(key);
};

export const removeLocalStorage = (key: string) => {
  if (key === 'mockTest') {
    mockTestMemory = null;
    return;
  }
  // localStorage.removeItem(key);
};

export const updateQuestion = (questionId: string, selectedAnswer?: string) => {
  const mockTest = getLocalStorage('mockTest');
  if (mockTest) {
    const mockTestData = JSON.parse(mockTest);
    mockTestData.answers = mockTestData.answers || [];

    // Check if answer for this question already exists
    const existingAnswerIndex = mockTestData.answers.findIndex(
      (answer: { questionId: string }) => answer.questionId === questionId
    );

    if (existingAnswerIndex >= 0) {
      // Update existing answer
      mockTestData.answers[existingAnswerIndex].selectedAnswer =
        selectedAnswer || null;
    } else {
      // Add new answer
      mockTestData.answers.push({
        questionId,
        selectedAnswer: selectedAnswer || null,
      });
    }

    saveLocalStorage('mockTest', mockTestData);
  }
};

export const getTextQuestionByIndex = (index: number) => {
  const mockTest = getLocalStorage('mockTest');
  if (mockTest) {
    const mockTestData = JSON.parse(mockTest);
    if (mockTestData.answers && mockTestData.answers[index]) {
      return mockTestData.answers[index];
    }
  }
  return null;
};

export const updateMocketestLocalStorage = (step: MockTestSteps) => {
  const mockTest = getLocalStorage('mockTest');
  if (mockTest) {
    const mockTestData: MockTestOtpVerified = JSON.parse(mockTest);
    const mockTestStep: MockTestStep = {
      step,
      isSubmitted: false,
    };
    mockTestData.step = mockTestStep;
    saveLocalStorage('mockTest', mockTestData);
  }
};
